import { render, staticRenderFns } from "./OfficeDetail.vue?vue&type=template&id=6b4bdfc5&scoped=true&"
import script from "./OfficeDetail.vue?vue&type=script&lang=js&"
export * from "./OfficeDetail.vue?vue&type=script&lang=js&"
import style0 from "./OfficeDetail.vue?vue&type=style&index=0&id=6b4bdfc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4bdfc5",
  null
  
)

export default component.exports